import "./home/home.scss";

window.addEventListener("load", () => {
  //@todo convert js-loadImage into designsystem component
  document.querySelectorAll(".loadImage").forEach((loadImage) => {
    const dest = loadImage.querySelector(".loadImage__wrapper"),
      img = new Image();
    const imgName = loadImage.dataset.img;
    img.src = new URL(`../images/${imgName}`, import.meta.url).href;
    img.onload = function () {
      dest.classList.add("loadImage__wrapper--loaded");
      dest.style.setProperty("--background", "url(" + img.src + ")");
    };
  });

  if (mqTabletLandscapeUp.matches) videoControl(true); //on load, play video if not mobile
});

const videoElement = document.getElementById("heroVideo");
const playPauseButton = document.getElementById("heroVideo__button");

playPauseButton.addEventListener("click", () => {
  videoControl(videoElement.paused); //if the video is pause, play it
});

videoElement.addEventListener("ended", () => {
  playPauseButton.classList.remove("videoControl--playing");
});

//media query video play/pause
const mqTabletLandscapeUp = window.matchMedia("(min-width: 900px)");
mqTabletLandscapeUp.addEventListener("change", (event) => {
  handleTabletLandscapeUp(event);
});
handleTabletLandscapeUp(mqTabletLandscapeUp);

function videoControl(play) {
  if (play) {
    videoElement.play();
    playPauseButton.classList.add("videoControl--playing");
  } else {
    videoElement.pause();
    playPauseButton.classList.remove("videoControl--playing");
  }
}

function handleTabletLandscapeUp(event) {
  if (!event.matches) {
    //if the screen is less than 900px wide, pause the video
    videoControl(false);
  }
}

//Set header height for hero video card
const header = document.getElementById("js-siteHeader");
const headerResizeObserver = new ResizeObserver((entries) => {
  const entry = entries[0];
  const contentBoxSize = entry.contentBoxSize[0];
  document.body.style.setProperty(
    "--headerHeight",
    Math.floor(contentBoxSize.blockSize) + "px"
  );
});
headerResizeObserver.observe(header);
